import React, { useRef } from 'react';
import { Chart, ChartData, ChartOptions } from 'chart.js';
import { Chart as ChartJS } from 'react-chartjs-2';
import { FiltroSopInventory } from '../../core/repositories/sopInventoryRepositorio';
import SopLoadingAnimation from '../../components/sopLoadingAnimation';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../core/contexts/toast';
import { RepositorioSopInventory } from '../../core/repositories/sopInventoryRepositorio';
import { useAutenticação } from '../../core/contexts/auth';
import { customPlugin, optionsChart } from '../SopSales/SopSalesSalesForecastChart';


interface Props {
    filtro: FiltroSopInventory;
    valor?: number;
}

const SopInventoryGrowthChart: React.FC<Props> = (props) => {
    const chartRef = useRef<Chart<'bar'>>(null);
    const { mostrarToast } = useToast();
    const { t } = useTranslation();
    const [data, setData] = React.useState<ChartData<"bar" | "line">>({} as ChartData<"bar" | "line">);
    const [carregando, setCarregando] = React.useState(true);
    const { usuario } = useAutenticação()


    React.useEffect(() => {
        if (usuario && usuario.cod_usuario) {
            props.filtro.cod_usuario = usuario.cod_usuario;

            setCarregando(true);
            new RepositorioSopInventory().getForecast(props.filtro).then((res) => {
                const labels: string[] = [];
                const real: (number | null)[] = [];
                const forecast: (number | null)[] = [];
                const forecastDestaque: (number | null)[] = [];
                const budget: (number | null)[] = [];
                const forecastReal: (number | null)[] = [];

                res.forEach((item: any) => {
                    labels.push(item.mes || "");
                    real.push(item.real);
                    // forecast.push(item.hasOwnProperty('forecast') ? item.forecast : null);
                    budget.push(item.hasOwnProperty('budget') ? item.budget : null);


                    forecast.push(Math.max((item.forecast || 0), (item.num_inventory_new || 0)));
                    forecastDestaque.push(item.num_inventory_new);
                    forecastReal.push(item.forecast)

                });

                setData({
                    labels: labels,
                    datasets: [
                        {
                            label: 'Actual',
                            data: real,
                            borderColor: '#1e88e5',
                            backgroundColor: '#1e88e5',
                            // tension: 0.4,
                            // pointRadius: 4,
                            // fill: false,
                        },

                        {
                            label: 'Forecast - Edit',
                            data: forecastDestaque,
                            showLine: false,
                            borderWidth: 0,
                            backgroundColor: 'transparent',
                            pointRadius: 0,
                            type: 'line',
                        },
                        {
                            label: 'Forecast - Real',
                            data: forecastReal,
                            borderWidth: 0,
                            backgroundColor: 'transparent',
                            pointRadius: 0,
                            type: `line`,
                        },
                        {
                            label: 'Forecast',
                            data: forecast,
                            borderColor: '#90CAF9',
                            backgroundColor: '#90CAF9',
                            // tension: 0.4,
                            // pointRadius: 3,
                            // fill: false,
                        },
                        {
                            label: 'Budget',
                            type: 'line', // <- Isso transforma em linha
                            data: budget,
                            borderColor: '#9e9e9e',
                            // borderDash: [3, 3],
                            backgroundColor: '#9e9e9e',
                            pointRadius: 0,
                            fill: false,
                        }

                    ],
                });
                setCarregando(false);
            }).catch((error) => {
                setCarregando(false);
                mostrarToast({
                    titulo: t("pages.Erro!"),
                    mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
                    tipo: "error",
                });
            })
        }
    }, [props.filtro, usuario]);


    const options = () => {
        return optionsChart(props)
    }


    return (

        <div className="card p-3 shadow-sm border-0" style={{ height: '250px' }}>
            <strong className=" title-card">Inventory</strong>
            {carregando ?
                <SopLoadingAnimation type="CHARTS" />
                :
                <div>
                    <ChartJS id="inventory" ref={chartRef} type='bar' options={options()} data={data} plugins={[{ id: 'partialBarHighlight3', afterDatasetsDraw: customPlugin }]} />
                </div>
            }

        </div>
    );
};

export default SopInventoryGrowthChart;